import type { AccountManager } from "../types";

export type { AccountManager } from "../types";

export const MOCK_ACCOUNT_MANAGERS: AccountManager[] = [
  {
    id: "r-sreenivas",
    initials: "RS",
    name: "R Sreenivas",
    role: "operations-lead",
    roleLabel: "Operations Lead",
    staffRole: "admin",
    email: "ravi.sreenivas@netshieldtech.com",
    phone: "+91 98765 43210",
    joined: "Jan 2024",
    customerCount: 38,
    inOnboarding: 6,
    installed: 2,
    lastActivity: "2 min ago",
  },
  {
    id: "j-patel",
    initials: "JP",
    name: "J Patel",
    role: "onboarding-manager",
    roleLabel: "Onboarding Manager",
    staffRole: "admin",
    email: "jpatel@netshieldtech.com",
    phone: "+91 91234 56780",
    joined: "Mar 2024",
    customerCount: 34,
    inOnboarding: 5,
    installed: 1,
    lastActivity: "14 min ago",
  },
  {
    id: "a-mehta",
    initials: "AM",
    name: "A Mehta",
    role: "onboarding-manager",
    roleLabel: "Onboarding Manager",
    staffRole: "admin",
    email: "amehta@netshieldtech.com",
    phone: "+65 8123 4567",
    joined: "Jul 2024",
    customerCount: 29,
    inOnboarding: 4,
    installed: 0,
    lastActivity: "1 h ago",
  },
  {
    id: "k-wong",
    initials: "KW",
    name: "K Wong",
    role: "onboarding-manager",
    roleLabel: "Onboarding Manager",
    staffRole: "admin",
    email: "kwong@netshieldtech.com",
    phone: "+44 7700 900123",
    joined: "Oct 2024",
    customerCount: 22,
    inOnboarding: 2,
    installed: 0,
    lastActivity: "3 h ago",
  },
  {
    id: "d-reyes",
    initials: "DR",
    name: "D Reyes",
    role: "onboarding-manager",
    roleLabel: "Onboarding Manager",
    staffRole: "admin",
    email: "dreyes@netshieldtech.com",
    phone: "+1 415 555 0198",
    joined: "Feb 2025",
    customerCount: 19,
    inOnboarding: 1,
    installed: 0,
    lastActivity: "5 h ago",
  },
];

export const ACCOUNT_MANAGER_SUMMARY = {
  active: MOCK_ACCOUNT_MANAGERS.length,
  customersCovered: MOCK_ACCOUNT_MANAGERS.reduce(
    (sum, manager) => sum + manager.customerCount,
    0,
  ),
};
